import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Register.css';  // Asegúrate de importar el archivo CSS
import logoApp from '../images/logo-app.png'
import '../styles/Logo.css';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();  // Hook para la navegación
  const [message, setMessage] = useState('');


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setMessage('Un momento por favor.');
      // const response = await axios.post('http://localhost:8882/rafa_register', { name, email, password })
      const response = await axios.post('https://services.neuralactions.com/api/saas_register', { name, email, password });
      console.log('User registered successfully:', response.data);
      // Redirigir o mostrar un mensaje de éxito
      const token = response.data.token;
        localStorage.setItem('token', token); // Guarda el token en localStorage
        console.log('Token guardado:', token);
        const token_expiration = response.data.token_expiration;
        localStorage.setItem('token_expiration', token_expiration); // Guarda el token en localStorage
        const user_id = response.data.user_id;
        localStorage.setItem('user_id', user_id); // Guarda el token en localStorage
        setMessage('Usuario creado');
        navigate('/'); 
    } catch (error) {
      console.error('Error registering user:', error);
      setMessage('Hubo un error. Inténtalo nuevamente.');
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <h2 className="register-title">Crear usuario</h2>
        <div>
            <img src={logoApp} className="imagen-logo" alt="NeuralActions Miralls del temps"/>
        </div>
        <h2>Registrate para comenzar</h2>
        <form onSubmit={handleSubmit}>
          <input 
            type="name" 
            placeholder="Ingresa tu nombre completo" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            className="input-field"
          />
          <input 
            type="email" 
            placeholder="Ingresa tu correo" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            className="input-field"
          />
          <input 
            type="password" 
            placeholder="Ingresa una contraseña" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            className="input-field"
          />
          <button type="submit" className="submit-btn">Registrarse</button>
        </form>
        {message && <p className="message">{message}</p>}
        <button className="back-btn" onClick={() => navigate('/login')}>
          Ya tengo cuenta
        </button>
      </div>
    </div>
  );
};

export default Register;
